import { useEffect, useState } from 'react';

// Polls /api/announcement.php every 60s. Falls back silently if not deployed.
const POLL_MS = 60000;

export const useAnnouncement = () => {
  const [state, setState] = useState({ text: '', image: '', updatedAt: 0, loaded: false });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await fetch('/api/announcement.php', { cache: 'no-store' });
        if (!res.ok) throw new Error('bad status');
        const data = await res.json();
        if (!mounted) return;
        setState({
          text: String(data.text || ''),
          image: String(data.image || ''),
          updatedAt: Number(data.updatedAt || 0),
          loaded: true,
        });
      } catch {
        if (mounted) setState((s) => ({ ...s, loaded: true }));
      }
    };
    load();
    const t = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  return state;
};
